import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNoIndex } from "../hooks/useNoIndex";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

export default function AdminLogin() {
  useNoIndex();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(username, password);
    setLoading(false);
    if (res.success) navigate("/admin");
    else setError(res.error || "Credenciales incorrectas");
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6">
      <form onSubmit={handleSubmit} data-testid="admin-login-form" className="w-full max-w-sm border border-white/10 bg-twp-charcoal/40 p-10">
        <h1 className="font-serif-display text-3xl text-white mb-2 text-center">Panel Privado</h1>
        <p className="text-white/40 text-xs uppercase tracking-[0.2em] text-center mb-8">The Wedding Photographie</p>

        {error && <p data-testid="admin-login-error" className="text-red-400 text-sm mb-4 text-center">{error}</p>}

        <div className="space-y-5">
          <div>
            <Label className="text-white/60 text-xs uppercase tracking-wider">Correo electrónico</Label>
            <Input data-testid="admin-login-username" type="email" value={username} onChange={(e) => setUsername(e.target.value)} className="bg-black border-white/20 text-white mt-2" />
          </div>
          <div>
            <Label className="text-white/60 text-xs uppercase tracking-wider">Contraseña</Label>
            <Input data-testid="admin-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-black border-white/20 text-white mt-2" />
          </div>
          <Button type="submit" data-testid="admin-login-submit" disabled={loading} className="w-full bg-twp-gold text-black hover:bg-white uppercase text-xs tracking-[0.2em] py-6">
            {loading ? "Ingresando..." : "Ingresar"}
          </Button>
        </div>
      </form>
    </div>
  );
}
